import type { CompanyFollower } from "@/modules/companies/client/api/types"
import type { NextRequest } from "@/modules/fetch/types"

import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"
import { toCamelCaseKeys } from "@/modules/format/object/toCamelCaseKeys"
import { toSnakeCaseKeys } from "@/modules/format/object/toSnakeCaseKeys"

type CompanyFollowerRequest = {
  permalink: string
  nextRequest?: NextRequest
}

const COMPANY_FOLLOWER_ENDPOINT = "/jobteaser.company.follow.v1alpha1/FollowService/CompanyFollower"

export const getCompanyFollower = async ({
  nextRequest,
  ...restParams
}: CompanyFollowerRequest): Promise<CompanyFollower> => {
  return fetcher(COMPANY_FOLLOWER_ENDPOINT, {
    nextRequest,
    requestInit: {
      body: JSON.stringify(toSnakeCaseKeys(restParams)),
      method: "POST",
    },
    serviceDomain: "APIGW_IN_KRAKEND_API",
  })
    .then(getResultFromResponse<CompanyFollower>({ transformResult: toCamelCaseKeys<CompanyFollower> }))
    .catch(handleFetchError(COMPANY_FOLLOWER_ENDPOINT))
}
